module.exports = __webpack_public_path__ + "static/img/home-pub-pe.4563225a.jpg";